import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./styles/interTight.latin.css";
import "./styles/tokens.v2.scss";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/bootstrap-custom.scss";
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { queryClient } from "./utils/queryClient.js";
// datadog disabled for now; uncomment this import and initDatadog() below to re-enable.
//import { initDatadog } from "./utils/datadogConfig.js";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { deferThirdPartyTracking } from "./utils/deferThirdParty.js";
import { installStaleAssetReload, isStaleAssetError, reloadOnce } from "./utils/staleAssetReload.js";

installStaleAssetReload();
// datadog disabled for now; uncomment this import and initDatadog() below to re-enable.
//initDatadog();
deferThirdPartyTracking();

const StaleAssetErrorFallback = ({ error }) => {
  useEffect(() => {
    if (isStaleAssetError(error)) reloadOnce();
  }, [error]);

  return (
    <div className="error-boundary">
      <h2>Something went wrong!</h2>
      <p>{error?.message}</p>
      <button type="button" onClick={() => window.location.reload()}>Try again</button>
    </div>
  );
};

const ReactQueryDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      import("@tanstack/react-query-devtools").then((module) => ({
        default: module.ReactQueryDevtools,
      }))
    )
  : null;

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: localStoragePersister,
        maxAge: Infinity,
      }}
    >
      <BrowserRouter>
        <ErrorBoundary fallback={(props) => <StaleAssetErrorFallback {...props} />}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </ErrorBoundary>
      </BrowserRouter>
      {ReactQueryDevtools && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </React.Suspense>
      )}
    </PersistQueryClientProvider>
  </React.StrictMode>
);
